module.exports = __webpack_public_path__ + "static/media/covid-19_Header.d7265326.png";